const HeroSection = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.pexels.com/photos/950241/pexels-photo-950241.jpeg"
          alt="Minimalist interior"
          className="w-full h-full object-cover opacity-10"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-32 md:py-40">
        <div className="max-w-4xl">
          {/* Small Label */}
          <p
            data-testid="hero-label"
            className="font-body text-sm tracking-[0.2em] uppercase text-[#B89F7C] mb-6 animate-fade-in-up opacity-0"
          >
            Nouveau canal de distribution
          </p>

          {/* Main Headline */}
          <h1
            data-testid="hero-headline"
            className="font-heading text-5xl sm:text-6xl lg:text-7xl font-light tracking-tighter leading-tight text-[#0A0A0A] mb-8 animate-fade-in-up opacity-0 animation-delay-100"
          >
            Le parfum réinventé
            <br />
            <span className="italic">dans le quotidien</span>
          </h1>

          {/* Subtitle */}
          <p
            data-testid="hero-subtitle"
            className="font-body text-lg sm:text-xl font-light leading-relaxed text-[#525252] max-w-2xl mb-12 animate-fade-in-up opacity-0 animation-delay-200"
          >
            Distribuez vos parfums via des diffuseurs intelligents installés
            dans des lieux premium : salles de sport, hôtels, espaces de
            coworking.
          </p>

          {/* CTAs */}
          <div
            className="flex flex-col sm:flex-row gap-4 animate-fade-in-up opacity-0 animation-delay-300"
          >
            <button
              onClick={() => scrollToSection("contact")}
              data-testid="hero-cta-primary"
              className="bg-[#0A0A0A] text-white hover:bg-[#B89F7C] transition-colors duration-300 px-8 py-4 text-sm tracking-widest uppercase font-medium"
            >
              Réserver un appel
            </button>
            <button
              onClick={() => scrollToSection("solution")}
              data-testid="hero-cta-secondary"
              className="bg-transparent border border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#FAFAFA] transition-colors duration-300 px-8 py-4 text-sm tracking-widest uppercase font-medium"
            >
              Découvrir
            </button>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-10 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-[1px] h-16 bg-gradient-to-b from-[#0A0A0A] to-transparent"></div>
      </div>
    </section>
  );
};

export default HeroSection;
